/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cx from 'classnames';
import { requestAllStores } from 'actionCreators';
import { getStoreList, getStoreLoaded } from '../../../../reducers';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';

class StoreSelect extends Component {
  componentDidMount() {
    if (!this.props.loaded) {
      this.props.requestAllStores();
    }
  }

  render() {
    const { className, loaded, ...props } = this.props;
    return (
      <ReactSelect
        multi
        resetValue={[]}
        name="store"
        label="Stores"
        className={cx(reactSelectStyles, className)}
        {...props}
      />
    );
  }
}

StoreSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
    vendor: PropTypes.string,
  })),
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.number,
  ]),
  className: PropTypes.string,
  loaded: PropTypes.bool.isRequired,
  requestAllStores: PropTypes.func.isRequired,
};

const getStoreOptions = createSelector(
  getStoreList,
  stores => stores.map(store => ({
    value: store.id,
    label: `${store.number} - ${store.name}`,
    vendor: store.vendor,
  })),
);

export default connect(
  state => ({ loaded: getStoreLoaded(state), options: getStoreOptions(state) }),
  { requestAllStores },
)(StoreSelect);



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/StoreSelect/index.jsx